//frontend/src/components/layout/Footer.jsx
const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-gray-200 py-6 px-6 mt-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          {/* Left side */}
          <div className="text-center md:text-left">
            <p className="text-sm text-gray-600">
              © {currentYear} <span className="font-semibold text-primary-600">Pingo Delivery</span>. Бүх эрх хуулиар хамгаалагдсан.
            </p>
          </div>

          {/* Right side */}
          <div className="flex items-center gap-6">
            <a href="#" className="text-sm text-gray-600 hover:text-primary-600 transition">
              Тусламж
            </a>
            <a href="#" className="text-sm text-gray-600 hover:text-primary-600 transition">
              Холбоо барих
            </a>
            <a href="#" className="text-sm text-gray-600 hover:text-primary-600 transition">
              Үйлчилгээний нөхцөл
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;